var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-people",
    d: "M3606.472,11006.234a.627.627,0,0,1-.643-.611v-1.634a3.364,3.364,0,0,1,.578-1.873c.061-.086.121-.168.186-.245a3.486,3.486,0,0,1,.689-.653,3.723,3.723,0,0,1,2.186-.7,3.683,3.683,0,0,1,2.183.7,2.98,2.98,0,0,1,.389.318,3.567,3.567,0,0,1,.493.58,3.355,3.355,0,0,1,.573,1.873v1.634a.625.625,0,0,1-.641.611Zm7.308-.816v-1.427a3.828,3.828,0,0,0-.706-2.2c-.065-.094-.138-.185-.2-.253a3.5,3.5,0,0,0-.414-.431,3.752,3.752,0,0,0-.309-.259,3.112,3.112,0,0,1,1.4-.327,3.054,3.054,0,0,1,2.057.772,2.537,2.537,0,0,1,.856,1.883v1.632a.643.643,0,0,1-.672.611Zm-10.639,0a.643.643,0,0,1-.672-.611v-1.635a2.8,2.8,0,0,1,2.913-2.652,3.129,3.129,0,0,1,1.4.327,4.2,4.2,0,0,0-.684.646,3.434,3.434,0,0,0-.23.293,3.792,3.792,0,0,0-.713,2.2v1.429Zm8.4-7.347a2.026,2.026,0,1,1,2.018,1.836A1.934,1.934,0,0,1,3611.537,10998.071Zm-4.086,0a2.026,2.026,0,1,1,2.016,1.836A1.933,1.933,0,0,1,3607.451,10998.071Zm-4.086,0a2.025,2.025,0,1,1,2.016,1.836A1.932,1.932,0,0,1,3603.365,10998.071Z",
    transform: "translate(-3602.469 -10996.234)",
    fill: "#7b7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.4d52b6a616569170948c16447757f40e.svg";
export { ForwardRef as ReactComponent };